aucor_navigation(document.getElementById('primary-navigation'), {
  desktop_min_width: 992,
  menu_toggle: '#menu-toggle'
});





if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function (e) {

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function () {
      objectFitPolyfill();
    });

  });
};


$('.owl-carousel').owlCarousel({
  navigation: true, // Show next and prev buttons
  slideSpeed: 300,
  paginationSpeed: 400,
  singleItem: true,
  items: 1,
  navText: true,
  nav: true,
})


var allTabsBtn = document.querySelectorAll('.tabs__item--button')

function openCity(cityName) {
  var i;
  var x = document.getElementsByClassName("desc__item");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }

  allTabsBtn.forEach(btn => btn.classList.remove('tabs__item--button--active'))
  const btn = document.querySelector(`button.${cityName}`)
  btn.classList.add('tabs__item--button--active')


  document.getElementById(cityName).style.display = "block";
}

$(document).ready(function () {
  $('.shop').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [{
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        }
      },

      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }


    ]
  })
})

const menuToggler = document.querySelector('#menu-toggle')
const primaryNav = document.querySelector('#primary-navigation')

const subMenu = document.querySelector(".sub-menu")



menuToggler.addEventListener('click', () => {
  if (menuToggler.classList.contains()) {

  }

})

document.addEventListener('click', function () {
  // subMenu.classList.remove('open')
})
